export const eraLabel = (s) => {
  if (s <= 1994) return "1990–1994 · Early 90s";
  if (s <= 1999) return "1995–1999 · Late 90s";
  if (s <= 2004) return "2000–2004 · Early 2000s";
  return "2005–2009 · Late 2000s";
};

export const eraBucket = (s) => {
  if (s <= 1994) return "1990-1994";
  if (s <= 1999) return "1995-1999";
  if (s <= 2004) return "2000-2004";
  return "2005-2009";
};

export const CATEGORY_LABELS = {
  Candy: "Candy & Toffee",
  Chocolate: "Chocolate",
  Biscuit: "Biscuit",
  Chips: "Chips & Namkeen",
  Drink: "Cold Drink",
  PowderedDrink: "Summer Drink",
  IceCream: "Ice Cream",
  Churan: "Churan",
  StreetFood: "Street Food",
};
